import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class GetEnclosureCardErrorAction implements Action {
  public static readonly type = 'GetEnclosureCardErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetEnclosureCardErrorAction.type;
}
